import { useQuery } from 'react-query';
import { useIntentContext } from '../../hooks';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// API REQUESTS
import { fetchConsumerIntPFAData } from '../../api';

// COMPONENTS
import DemandF from './PFA_comp/DemandF';
import DemandFG from './PFA_comp/DemandFG';
import YoYChange from './PFA_comp/YoYChange';
import OutletSpinner from '../OutletSpinner';
import ProductGrowth from './PFA_comp/ProductGrowth';
import YoYChangeDemandFTR from './PFA_comp/YoYChangeDemandFTR';
import MindsetBreakdownperProduct from './PFA_comp/MindsetBreakdownperProduct';

const ProductFeatureAnalysis: React.FC = () => {
  const { selectedProducts, selectedVerticals, dateRange } = useIntentContext();
  const [searchParams] = useSearchParams();
  const usecases = searchParams.get('usecases');

  // Reference for the GrowingBrand component
  const featureGraphRef = useRef<HTMLDivElement>(null);

  const {
    error,
    data: consumerIntPFAData,
    isLoading,
  } = useQuery(
    [
      'consumerIntPFAData',
      dateRange?.startDate,
      dateRange?.endDate,
      selectedVerticals,
      selectedProducts,
    ],
    () =>
      fetchConsumerIntPFAData(dateRange, selectedVerticals, selectedProducts),
    {
      enabled: !!dateRange?.startDate && !!dateRange.endDate,
    }
  );

  // Scroll to GrowingBrand component when the page loads with usecases=macro_trends_shifts
  useEffect(() => {
    // get window width
    const windowWidth = window.innerWidth;
    let offset = 100;

    if (windowWidth < 1324 && windowWidth > 923) {
      offset = -90;
    } else if (windowWidth <= 923) {
      offset = 0;
    }

    if (usecases === 'macro_trends_shifts' && featureGraphRef.current) {
      window.scrollTo({ 
        top: featureGraphRef.current.getBoundingClientRect().top + window.scrollY - offset, 
        behavior: 'smooth' 
      });      
    }
  }, [usecases, consumerIntPFAData]);

  // JSX
  return isLoading ? (
    <OutletSpinner />
  ) : error ? (
    <div>Error occurred while fetching data.</div>
  ) : consumerIntPFAData ? (
    <>
      <ProductGrowth
        data={consumerIntPFAData?.product_growth_and_decline_chart}
        fastest_growing_product={
          consumerIntPFAData?.fastest_growing_product_scorecard
        }
        emerging_products={consumerIntPFAData?.emerging_products_scorecard}
        fastest_growing_product_real_terms={
          consumerIntPFAData?.fastest_growing_product_real_terms_scorecard
        }
      />
      <MindsetBreakdownperProduct
        data={consumerIntPFAData?.mindset_breakdown_per_product_chart}
      />
      <DemandFG data={consumerIntPFAData?.demand_by_feature_group_chart} />
      <div ref={featureGraphRef}>
        <DemandF data={consumerIntPFAData?.demand_by_feature_chart} />
      </div>
      <YoYChange
        data={consumerIntPFAData?.yoy_change_in_demand_by_feature_group_chart}
      />
      <YoYChangeDemandFTR
        data={consumerIntPFAData?.yoy_change_in_demand_by_feature_chart}
      />
    </>
  ) : null;
};

export default ProductFeatureAnalysis;
